import {
  StateRule,
  StateTransitionOptions,
  StateResult,

  StateNavigationAction,
  Transition,
  // eslint-disable-next-line
  addNavigationElement,
  // eslint-disable-next-line
  addEmptyNavigationElement,
  addPreviousNext,
  // eslint-disable-next-line
  addPrevious,
  // eslint-disable-next-line
  addNext,  
  newTransition,
  newTransitionCondition
} from "../StateInterfaces";

import { BaseState }  from "../StateMachine";
import { StateHome } from "./StateHome";
import { StateLogin } from "./StateLogin";
import { NavigatonIcons } from "@/business/application/NavConst";
import {Commands} from "@/business/application/commands/Command";


export class StateKarte extends BaseState {
  private static mainState = "Karte";
  private static transitions: Transition[] = [];
  private isBackward = false


  public constructor() {
    super()    
  }

  public getStartTransition(condition: string) : StateResult {
    StateKarte.transitions = []
    this.getTransitions()
    const t = this.getTransitions()[0];
    return this.getTransition(t);
  }

  public next(rule: StateRule, options: StateTransitionOptions): StateResult {
    return this.calculateState(
      rule,
      options,
      false,
      StateKarte.mainState
    );
  }

  public previous(
    rule: StateRule,
    options: StateTransitionOptions
  ): StateResult {
    return this.calculateState(
      rule,
      options,
      true,
      StateKarte.mainState
    );
  }

  protected checkState(
    transition: Transition,
    options: StateTransitionOptions
  ): StateResult {
    const context = this.getContext()
    let newResultState = this.getTransition(transition);
    let newState: any
    if (!options.lookahead && transition.newState != "") {
      switch (transition.newMainState) {
        case "Home":
          newState = new StateHome();
          newResultState = newState.getStartTransition("Home")
          this.getContext().transitionTo(newState,newResultState)             
          break;
        case "Login":
          newState = new StateLogin();
          newResultState = newState.getStartTransition("Login")
          this.getContext().transitionTo(newState,newResultState)             
          break;
        default:
          context.transitionTo(
            new StateKarte(),
            newResultState
          );
      }
    }
    return newResultState;
  }

  protected calculateState(
    rule: StateRule,
    options: StateTransitionOptions,
    isPrevious: boolean,
    // eslint-disable-next-line
    mainState: string
  ): StateResult {
    this.isBackward = isPrevious
    const context = this.getContext()
    const condition = this.calculateBusinessConditions(
      rule,
      context.getCurrentState()
    );


    if ( isPrevious) {
      let transition = this.getTransitions().filter(row => {
        if (row.nav === StateNavigationAction.Previous && row.condition === "TargetTest" ) {
          return true;
        }
      })
      if ( transition.length > 0 ) {
        return this.checkState(transition[0], options);
      }
      transition = this.getTransitions().filter(row => {
        if (row.nav === StateNavigationAction.Previous && row.oldState === context.getCurrentState().newState && row.condition === "" ) {
          return true;
        }
      })
      return this.checkState(transition[0], options);
    }

    else {
      const transitionNext = this.getTransitions().filter(row => {
        if (row.nav === StateNavigationAction.Next && row.oldState === context.getCurrentState().newState && row.condition === "" ) {
          return true;
        }
      })
      return this.checkState(transitionNext[0], options);
    }   
  }

  protected calculateBusinessConditions(
    rule: StateRule,
    resultState: StateResult
  ): string {
    return ""
  }

  public getTransitions(): Transition[] {
    if (StateKarte.transitions.length === 0) {

      //*****************************************
      //--> Start Request from other Main-State
      //*****************************************
      let t: Transition = { mainState: "Login", newMainState: "Karte", nav: StateNavigationAction.Next, oldState: "Login", newState: "Karte", condition: "Login"};      
      t = addPrevious(t, Commands.PreviousPage);
      StateKarte.transitions.push(t);

      t = { mainState: "Home", newMainState: "Karte", nav: StateNavigationAction.Next, oldState: "Home", newState: "Karte", condition: "Home"};      
      t = addPrevious(t, Commands.PreviousPage);
      StateKarte.transitions.push(t);

      t = { mainState: "Karte", newMainState: "Test", nav: StateNavigationAction.Previous, oldState: "Karte", newState: "Test", condition: "TargetTest"};      
      t = addPrevious(t, Commands.PreviousPage);
      StateKarte.transitions.push(t);

     


    }
    return StateKarte.transitions;
  }
}
